import { gql } from '@apollo/client';

export const GQL_VERSION_QUERY = gql`
  query gqlVersion {
    gqlVersion {
      version
      date
    }
  }
`;

export const API_VERSION_QUERY = gql`
  query apiVersion {
    apiVersion {
      version
      date
    }
  }
`;

export const DATABASE_VERSION_QUERY = gql`
  query databaseVersion {
    databaseVersion
  }
`;
